import styled from 'styled-components';
import Icon from '../../components/atoms/Icon';
import Theme from '../../styles/models/theme';

export const Container = styled.div<{theme?: Theme}>`
  display: flex;
  flex-direction: column;
  padding: 5vw;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 15px;
`;

export const IconButton = styled(Icon)`
  margin-left: 8px;
  &:active {
    opacity: 0.8;
  }
`;
